export default __webpack_public_path__ + "assets/sergio-franco-component.e91a5047.svg";